import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-duplicate-cmi-warning-modal',
    templateUrl: './duplicate-cmi-warning-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DuplicateCmiWarningModalComponent {
    public duplicates: any[] = [];

    constructor(public activeModal: DialogRef) {}
}
